(function () {
  var HEADER_SELECTOR = '[data-header-section]';

  function init(root) {
    if (!root || root.dataset.navInit === 'true') return;
    var toggleBtn = root.querySelector('[data-nav-toggle]');
    var closeBtn = root.querySelector('[data-nav-close]');
    var menu = root.querySelector('[data-nav-menu]');
    if (!toggleBtn || !closeBtn || !menu) return;
    root.dataset.navInit = 'true';

    var controller = new AbortController();
    root.headerNavController = controller;

    toggleBtn.addEventListener(
      'click',
      function () {
        menu.classList.remove('hidden');
        toggleBtn.setAttribute('aria-expanded', 'true');
        if (window.moLockScroll) window.moLockScroll();
      },
      { signal: controller.signal }
    );

    closeBtn.addEventListener(
      'click',
      function () {
        menu.classList.add('hidden');
        toggleBtn.setAttribute('aria-expanded', 'false');
        if (window.moUnlockScroll) window.moUnlockScroll();
      },
      { signal: controller.signal }
    );
  }

  function teardown(root) {
    if (!root) return;
    if (root.headerNavController) {
      root.headerNavController.abort();
      delete root.headerNavController;
    }
    root.removeAttribute('data-nav-init');
  }

  document.querySelectorAll(HEADER_SELECTOR).forEach(init);

  if (!window.__headerNavWired) {
    window.__headerNavWired = true;
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector(HEADER_SELECTOR);
      if (root) init(root);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector(HEADER_SELECTOR);
      if (root) teardown(root);
    });
  }
})();
